
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Column } from '@/utils/pdf-templates/types';
import { SortableSectionItem } from './SortableSectionItem';
import { cn } from '@/lib/utils';

interface ColumnContainerProps {
    column: Column;
}

export function ColumnContainer({ column }: ColumnContainerProps) {
    const { setNodeRef, isOver } = useDroppable({ id: column.id });

    return (
        <SortableContext id={column.id} items={column.sections.map(s => s.id)} strategy={verticalListSortingStrategy}>
            <div
                ref={setNodeRef}
                className={cn(
                    "space-y-2 min-h-[100px] bg-gray-50/50 p-2 rounded-md transition-all duration-200 flex-grow flex flex-col",
                    isOver ? "bg-green-100 border-green-400" : "border-gray-200",
                    "border-2 border-dashed"
                )}
            >
                <div className="flex-grow space-y-2">
                    {column.sections.map(section => (
                        <SortableSectionItem key={section.id} id={section.id}>
                            {section.name}
                        </SortableSectionItem>
                    ))}
                </div>
                {column.sections.length === 0 && (
                     <div className="flex-grow flex items-center justify-center h-full min-h-[100px]">
                        <p className="text-xs text-gray-400 text-center py-4">
                            اسحب الأقسام إلى هنا
                        </p>
                    </div>
                )}
            </div>
        </SortableContext>
    );
}
